var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "\n        productOfCardMain\n    " },
    [
      _c("div", { staticClass: "content" }, [
        _c("img", {
          staticClass: "productImg",
          attrs: { src: _vm.getImgUrl(_vm.productImg) }
        }),
        _vm._v(" "),
        _c("div", { staticStyle: { "flex-grow": "1", overflow: "hidden" } }, [
          _c(
            "div",
            {
              staticStyle: {
                "font-weight": "800",
                "white-space": "nowrap",
                "overflow-x": "auto"
              }
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.productName) +
                  "\n            "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "white-space": "nowrap", "overflow-x": "auto" } },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.specificationName) +
                  "\n            "
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "productPrice" }, [
            _vm._v(
              "\n                ￥" +
                _vm._s(_vm.productPrice.toFixed(1)) +
                "\n            "
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { ref: "addToCartView", staticClass: "stepper" },
        [
          _c("ProductIncAndDesc", {
            attrs: {
              maxBuyNum: _vm.checkMaxBuyNum(
                _vm.shopId,
                _vm.productId,
                _vm.specificationId
              ),
              maxNumber: _vm.stock
            },
            on: { dataChange: _vm.updateCart },
            model: {
              value: _vm.productNumberData,
              callback: function($$v) {
                _vm.productNumberData = $$v
              },
              expression: "productNumberData"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("BaseParabolaAnimate", {
        ref: "addToCartAnimate",
        attrs: { imgPic: _vm.getImgUrl(_vm.productImg) }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }